import { mapState } from "vuex";
import { Component, Vue } from "vue-property-decorator";
import { router } from "@/router";
import { superElfStarted } from "@/helpers/time-helper";
import store from "@/store";
import { Account } from "@/models/account.model";
import { HomeTiles } from "@/models/homeTiles.model";
import { homeService } from "@/services";
import homeTile from "./HomeTile.vue";
import cupTile from "./CupTile.vue";
import { favoriteService } from "@/services/favorite.service";

@Component({
  components: {
    homeTile,
    cupTile,
  },
  computed: {
    ...mapState("account", ["user"]),
  },
  metaInfo: {
    title: "Home",
  },
})
export default class Homepage extends Vue {
  public user!: Account;
  public tiles: HomeTiles = {} as HomeTiles;
  public loaded = false;

  // ✅ countdown state
  public countdown = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  };

  private countdownTimer: number | null = null;

  async created() {
    const favorites = favoriteService.getFavorites();
    this.tiles = await homeService.getTiles(favorites);
    this.loaded = true;

    this.updateCountdown();

    this.countdownTimer = window.setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  }

  // ✅ countdown logic
  public updateCountdown(): void {
    //@ts-ignore
    const startPool = store.state.settings.settings?.startSuperElf;

    if (!startPool) {
      this.countdown = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      };
      return;
    }

    const startDate = new Date(startPool);
    const diff = Math.max(startDate.getTime() - Date.now(), 0);

    this.countdown = {
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((diff / (1000 * 60)) % 60),
      seconds: Math.floor((diff / 1000) % 60),
    };
  }

  // existing computed-style getters
  get canCreateTeams() {
    //@ts-ignore
    return store.state.settings.settings.canCreateTeams;
  }

  get intro() {
    //@ts-ignore
    return store.state.settings.settings.intro;
  }

  get isStarted() {
    return superElfStarted();
  }

  // optional: formatted start time (Vue 2 computed getter)
  get formattedStartTime(): string {
    //@ts-ignore
    const startPool = store.state.settings.settings?.startSuperElf;

    if (!startPool) return "";

    return new Date(startPool).toLocaleString("nl-NL", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }
}
